module.exports = __webpack_public_path__ + "static/media/objects2_14.3580e3c6.svg";